// Hair Elixir — termékadatok a katalógus alapján
// Forrás: pothaj_katalogus.pdf (2026-04-30)
// Az ár-tól értékek automatikusan kalkulálódnak az Árlista alapján (computePrice).
// Variánsok: a vásárló a termékoldalon választ hossz+súly kombinációt.

export const ORIGINS = [
  { value: "europai", label: "Európai" },
  { value: "kazah", label: "Kazahsztáni" },
];

export const TYPES = [
  { value: "natur", label: "Natúr copf" },
  { value: "weft", label: "Tresszelt" },
];

const PLACEHOLDER = "/placeholder-product.svg";

const COMMON_INSTALL = "Mikrogyűrűs vagy hüvelyes beépítés szalonban";
const KZ_DESC =
  "Kazahsztáni eredetű, természetes selymességű emberi haj. Közepesen vastag szállal, intenzív természetes fénnyel. Festhető, hajvasalóval és sütővassal kezelhető. Megfelelő ápolás mellett évekig hordható.";
const EU_DESC =
  "Európai donortól származó, finomszálú emberi haj. Lágy textúra, puha tapintás — különösen jól illik finomszálú saját hajhoz. Természetes mozgású, festhető és hőkezelhető. Megfelelő ápolás mellett évekig hordható.";

// Sorrend: Európai (7) → Kazahsztáni (4)
export const PRODUCTS = [
  // ─────────── Európai (7) ───────────
  {
    id: "eu-12-platina",
    name: "Európai — 12-es Platina Szőke",
    origin: "europai",
    type: "natur",
    price: "- Ft",
    color: "12-es (platina szőke)",
    treatment: "Festett",
    texture: "Puha, hidratált",
    install: COMMON_INSTALL,
    description: EU_DESC,
    variants: [{ length: "66 cm", weight: "115 g" }],
    image: "/eu-hair/eu-1.jpg",
    aspect: "wide",
  },
  {
    id: "eu-10-szoke",
    name: "Európai — 10-es Szőke",
    origin: "europai",
    type: "natur",
    price: "- Ft",
    color: "10-es (világos szőke)",
    treatment: "Természetes",
    texture: "Puha, hidratált",
    install: COMMON_INSTALL,
    description: EU_DESC,
    variants: [{ length: "66 cm", weight: "100 g" }],
    image: "/eu-hair/eu-2.jpg",
    aspect: "tall",
  },
  {
    id: "eu-11",
    name: "Európai — 11-es",
    origin: "europai",
    type: "natur",
    price: "- Ft",
    color: "11-es (nagyon világos szőke)",
    treatment: "Természetes",
    texture: "Puha, hidratált",
    install: COMMON_INSTALL,
    description: EU_DESC,
    variants: [{ length: "55 cm", weight: "350 g" }],
    image: "/eu-hair/eu-3.jpg",
    aspect: "tall",
  },
  {
    id: "eu-9",
    name: "Európai — 9-es",
    origin: "europai",
    type: "natur",
    price: "- Ft",
    color: "9-es (szőke)",
    treatment: "Természetes",
    texture: "Puha, hidratált",
    install: COMMON_INSTALL,
    description: EU_DESC,
    variants: [{ length: "64 cm", weight: "200 g" }],
    image: "/eu-hair/eu-4.jpg",
    aspect: "tall",
  },
  {
    id: "eu-7",
    name: "Európai — 7-es",
    origin: "europai",
    type: "natur",
    price: "- Ft",
    color: "7-es (közép szőke / barna)",
    treatment: "Természetes",
    texture: "Puha, hidratált",
    install: COMMON_INSTALL,
    description: EU_DESC,
    variants: [
      { length: "55 cm", weight: "150 g" },
      { length: "63 cm", weight: "300 g" },
      { length: "68 cm", weight: "200 g" },
    ],
    image: "/eu-hair/eu-5.jpg",
    aspect: "tall",
  },
  {
    id: "eu-tresszelt-meliros",
    name: "Európai Tresszelt — Melíros",
    origin: "europai",
    type: "weft",
    price: "- Ft",
    color: "Melíros (több árnyalat)",
    treatment: "Festett",
    texture: "Puha, hidratált",
    install: "Tresszelt felhelyezés",
    description: EU_DESC,
    variants: [{ length: "65 cm", weight: "100 g" }],
    image: "/eu-hair/eu-7.jpg",
    aspect: "wide",
  },
  {
    id: "eu-6",
    name: "Európai — 6-os",
    origin: "europai",
    type: "natur",
    price: "- Ft",
    color: "6-os (sötét barna)",
    treatment: "Természetes",
    texture: "Puha, hidratált",
    install: COMMON_INSTALL,
    description: EU_DESC,
    variants: [{ length: "65 cm", weight: "100 g" }],
    image: "/eu-hair/eu-6.jpg",
    aspect: "tall",
  },

  // ─────────── Kazahsztáni (4) ───────────
  {
    id: "kz-natur-8",
    name: "Kazahsztáni Természetes — 8-as",
    origin: "kazah",
    type: "natur",
    price: "- Ft",
    color: "8-as (világos barna / sötét szőke)",
    treatment: "Természetes (vegykezelés-mentes)",
    texture: "Selymes, közép szálvastagságú",
    install: COMMON_INSTALL,
    description: KZ_DESC,
    variants: [{ length: "55 cm", weight: "300 g" }],
    image: "/kz-hair/kz-1.jpg",
    aspect: "tall",
  },
  {
    id: "kz-natur-6",
    name: "Kazahsztáni Természetes — 6-os",
    origin: "kazah",
    type: "natur",
    price: "- Ft",
    color: "6-os (sötét barna)",
    treatment: "Természetes (vegykezelés-mentes)",
    texture: "Selymes, közép szálvastagságú",
    install: COMMON_INSTALL,
    description: KZ_DESC,
    variants: [{ length: "55 cm", weight: "300 g" }],
    image: "/kz-hair/kz-3.jpg",
    aspect: "wide",
  },
  {
    id: "kz-fested-8",
    name: "Kazahsztáni Festett — 8-as",
    origin: "kazah",
    type: "natur",
    price: "- Ft",
    color: "8-as (világos barna / sötét szőke)",
    treatment: "Festett",
    texture: "Selymes, közép szálvastagságú",
    install: COMMON_INSTALL,
    description: KZ_DESC,
    variants: [{ length: "55 cm", weight: "300 g" }],
    image: "/kz-hair/kz-2.jpg",
    aspect: "tall",
  },
  {
    id: "kz-natur-9",
    name: "Kazahsztáni Természetes — 9-es Szőke",
    origin: "kazah",
    type: "natur",
    price: "- Ft",
    color: "9-es (szőke)",
    treatment: "Természetes (vegykezelés-mentes)",
    texture: "Selymes, közép szálvastagságú",
    install: COMMON_INSTALL,
    description: KZ_DESC,
    variants: [{ length: "55 cm", weight: "220 g" }],
    image: "/kz-hair/kz-4.jpg",
    aspect: "wide",
  },
];

// ─────────── Rendezés: kategóriánként (európai → kazahsztáni) hossz szerint növekvő ───────────
const parseCm = (s) => parseInt(String(s).replace(/[^\d]/g, ""), 10) || 0;
const minLengthCm = (p) => Math.min(...p.variants.map((v) => parseCm(v.length)));

// Variánsok rendezése terméken belül: hossz növekvő, súly növekvő
for (const p of PRODUCTS) {
  p.variants.sort((a, b) => {
    const dl = parseCm(a.length) - parseCm(b.length);
    if (dl !== 0) return dl;
    return parseCm(a.weight) - parseCm(b.weight);
  });
}

// Termékek rendezése: európai elöl, kazahsztáni utána, mindkettőn belül hossz növekvő
PRODUCTS.sort((a, b) => {
  if (a.origin !== b.origin) return a.origin === "europai" ? -1 : 1;
  return minLengthCm(a) - minLengthCm(b);
});

export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);

// Helpers a kompatibilitáshoz: bárhol használható egységes formázott felirat egy variánshoz.
export const variantLabel = (v) =>
  v ? `${v.length} · ${v.weight}` : "";
export const variantKey = (v) => (v ? `${v.length}__${v.weight}` : "");

// ─────────── Árlista (per 100g, HUF) — pothaj_katalogus.pdf alapján ───────────
const EU_PRICE_PER_100G = {
  55: { barna: 80000, szoke: 82000 },
  60: { barna: 82000, szoke: 84000 },
  65: { barna: 84000, szoke: 86000 },
  70: { barna: 86000, szoke: 88000 },
};
const KZ_PRICE_PER_100G = {
  55: { barna: 65000, szoke: 68000 },
  65: { barna: 66000, szoke: 68000 },
};

function lengthBucket(cmStr) {
  const cm = parseInt(cmStr, 10);
  if (!cm) return 65;
  if (cm <= 55) return 55;
  if (cm <= 60) return 60;
  if (cm <= 65) return 65;
  return 70;
}

function shadeCategory(product) {
  const name = (product.name || "").toLowerCase();
  if (/melíros|meliros/.test(name)) return "szoke";
  const m = (product.color || "").match(/(\d+)/);
  if (m) {
    const n = parseInt(m[1], 10);
    return n >= 9 ? "szoke" : "barna";
  }
  return "barna";
}

export function computePrice(product, variant) {
  if (!product || !variant) return null;
  const weight = parseInt(variant.weight, 10);
  if (!weight) return null;
  const bucket = lengthBucket(variant.length);
  const cat = shadeCategory(product);
  const table = product.origin === "europai" ? EU_PRICE_PER_100G : KZ_PRICE_PER_100G;
  const row = table[bucket] || table[55];
  const per100 = row?.[cat];
  if (!per100) return null;
  return Math.round((per100 * weight) / 100);
}

export function priceFrom(product) {
  if (!product?.variants?.length) return null;
  const prices = product.variants
    .map((v) => computePrice(product, v))
    .filter((n) => typeof n === "number");
  return prices.length ? Math.min(...prices) : null;
}

export function formatPrice(n) {
  if (n == null || isNaN(n)) return "- Ft";
  return new Intl.NumberFormat("hu-HU").format(Math.round(n)) + " Ft";
}

// Ár-tól címke a terméklistára
export function priceFromLabel(product) {
  return formatPrice(priceFrom(product));
}
